import React from 'react';

import IntelligenceCarsNavbar from './intelligenceCarsNavbar'
import IntelligenceCarsContent from './intelligenceCarsContent'
import SideContentInner from '../../../shared/sideContentInner'

const IntelligenceCars = () => {
  return (
    <React.Fragment>
      <IntelligenceCarsNavbar />

      <SideContentInner>
        <IntelligenceCarsContent />
      </SideContentInner>
    </React.Fragment>
  )
}

export default React.memo(IntelligenceCars)
